import React, { useMemo } from 'react'
import Form from 'react-bootstrap/Form'
import I18n from 'resources/i18n/I18n'

const CATEGORY_ORDER = ['Actions pénales', 'Actions civiles', 'Actions de proximité', 'Actions partenariales']

const groupByCategory = (complaints) => {
  if (!complaints) return {}
  const grouped = complaints.reduce((acc, complaint) => {
    if (!complaint.category) return acc
    if (!acc[complaint.category]) acc[complaint.category] = []
    acc[complaint.category].push(complaint)
    return acc
  }, {})

  const ordered = {}
  CATEGORY_ORDER.forEach((cat) => {
    if (grouped[cat]) ordered[cat] = grouped[cat]
  })
  Object.keys(grouped).forEach((cat) => {
    if (!ordered[cat]) ordered[cat] = grouped[cat]
  })
  return ordered
}

const ActionsGrid = ({ status, editStatus, complaints, selectedComplaintIds, previousComplaintIds, readOnly, onToggleComplaint }) => {
  const complaintsByCategory = useMemo(() => groupByCategory(complaints), [complaints])

  return (
    <div className="actions-section">
      <span className="subtitle">{I18n.t('Actions')}</span>
      <div className="actions-categories">
        {Object.entries(complaintsByCategory).map(([category, items]) => (
          <div key={category} className="action-category">
            <div className="action-category-title">{category}</div>
            {items.map((complaint) => (
              <div key={complaint.id} className="action-item">
                <Form.Check
                  type="checkbox"
                  id={`complaint-${complaint.id}-${status.id}`}
                  label={complaint.label}
                  checked={selectedComplaintIds.includes(complaint.id)}
                  onChange={() => onToggleComplaint(complaint.id)}
                  disabled={readOnly || previousComplaintIds.includes(complaint.id)}
                />
                {previousComplaintIds.includes(complaint.id) && <span className="action-traceability">action précédente</span>}
              </div>
            ))}
          </div>
        ))}
        <div className="action-category">
          <div className="action-category-title">Autres</div>
          <div className="action-item">
            <Form.Control
              as="textarea"
              rows={2}
              size="sm"
              placeholder="Autre action..."
              value={status.autreAction || ''}
              onChange={(e) => editStatus({ ...status, autreAction: e.target.value })}
              readOnly={readOnly}
              style={{ fontSize: 13 }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActionsGrid
